import React, { useEffect } from 'react';
import { API_USER } from '../../api/user';
import { useDispatch } from 'react-redux';
import {
  setCasinoActions,
  setCasinoList,
  setCurrencyList,
  setMainGroup
} from '../../store/apps/userSlice';
import { useAppSelector } from 'src/store';
import { ENUM_CUS_EVENT, ENUM_STRING_MENU, TEST_MODE } from '../../enums/enums';
import { mockCasinoList, mockCurrencies } from '../../enums/mock';
import useEventListeners from './useEventListener';
import useFillStoreByLcs from './useFillStoreByLcs';
import { dispatchCusEvent } from '../../utils';
import { setAddHiddenMenuItems, setRemoveHiddenMenuItems } from '../../store/apps/infoSlice';

export default function useCommonHooks() {
  const dispatch = useDispatch();
  useEventListeners();
  useFillStoreByLcs();
  const userId = useAppSelector((state) => state.user.id);
  const mainGroupName = useAppSelector((state) => state.user.group.main?.name);
  const superUser = useAppSelector((state) => state.user.superUser);

  useEffect(() => {
    if (!userId) return;

    if (TEST_MODE) {
      dispatch(setCurrencyList(mockCurrencies));
      dispatch(setCasinoList(mockCasinoList));
      dispatch(setCasinoActions({ create: false, config: false, delete: true }));

      return;
    }

    API_USER.getList
      .currency()
      .then((e) => {
        dispatch(setCurrencyList(e.data.list));
      })
      .catch(console.error);

    API_USER.group
      .main()
      .then((e) => {
        const data = e.data;

        dispatch(setMainGroup(data));
      })
      .catch(console.log);

    dispatchCusEvent(ENUM_CUS_EVENT.getCasinos);
  }, [userId]);

  useEffect(() => {
    if (!superUser) {
      dispatch(setAddHiddenMenuItems(ENUM_STRING_MENU.gambitAggregator));
    } else {
      dispatch(setRemoveHiddenMenuItems(ENUM_STRING_MENU.gambitAggregator));
    }
  }, [superUser]);
}
